export default __webpack_public_path__ + "static/icon-forklift-truck-b5949474ba132c4cf5f171935a9fb5fb.svg";